// Group Products

document.querySelectorAll('.product-single img').forEach(function(item, index) {

    item.onmouseenter = function(event) {
      event.stopPropagation();
      document.querySelectorAll('.product-single').forEach((item, index) => item.classList.remove('product-single-active'));
      event.target.closest('.product-single').classList.add('product-single-active');
    };
  
  });
  
  // document.querySelector('.product-group-wrapper').onmouseover = function(event) {
  //   if (!document.querySelector('[product-single-active]').classList.contains('product-single-active')) {
  //     document.querySelectorAll('.product-single').forEach((item, index) => item.classList.remove('product-single-active'));
  //     document.querySelector('[product-single-active]').classList.add('product-single-active');
  //   }
  // };
  
  // Product media controls
  var mediaControls = document.querySelectorAll('.product-gallery__media-control'),
      galleryNavigation = document.querySelector('.product-gallery--navigation'),
      selectedItem, selectedIndex, targetItem;
  
  var onMediaControlClick = function(event) {
    selectedItem = galleryNavigation.querySelector('[data-product-gallery-selected="true"]');
    selectedIndex = parseInt(selectedItem.dataset.productGalleryThumbnail);
  
    if (event.target.classList.contains('product-gallery__media-control--next')) {
      // Next
      targetItem = galleryNavigation.children[selectedIndex + 1];
  
      if (!targetItem) {
        targetItem = galleryNavigation.children[0];
      }
    } else {
      // Prev
      targetItem = galleryNavigation.children[selectedIndex - 1];
  
      if (!targetItem) {
        targetItem = galleryNavigation.children[galleryNavigation.children.length - 1];
      }
    }
  
    targetItem.click();
  };
  
  if (mediaControls && galleryNavigation) {
    for (var i = 0; i < mediaControls.length; i++) {
      mediaControls[i].addEventListener('click', onMediaControlClick);
    }
  }
  
  
  
  class StickyATC extends HTMLElement {
    constructor() {
      super();
      this.isVisible = false;
      this.variantUpdated = false;
      this.priceElement = null;
      this.buttonElement = null;
      this.loaderElement = null;
      this.observer = null;
    }
  
    connectedCallback() {
      this.priceElement = this.querySelector('[data-product-price]');
      this.buttonElement = this.querySelector('.sticky-atc__button');
      this.loaderElement = this.querySelector('[data-product-atc-loader]');
  
      this.observeVariantUpdates();
  
      this.buttonElement.addEventListener('click', this.onButtonClick.bind(this));
      window.addEventListener('scroll', this.onScroll.bind(this));
    }
  
    observeVariantUpdates() {
      const variantSelect = document.querySelector('select[data-variants]');
  
      if (variantSelect) {
        window.addEventListener('shopify-variants:switch-variant', (e) => {
          this.updatePrice(e.detail.variant);
          this.dataset.variant = e.detail.variant.id;
        });
      }
    }
  
    onScroll() {
      // get current scroll position using bottom of screen
      let stickyHeight = this.offsetHeight;
      let scrollY = window.scrollY + window.innerHeight - stickyHeight;
      const mainProductButton = document.querySelector('.product-details__add-to-cart-buttons .product-details__add-to-cart-button');
      // get current scroll position of mainProductButton from top of scroll container
      let mainProductButtonOffset = mainProductButton.offsetTop - 10;
      console.log(scrollY, mainProductButtonOffset, stickyHeight);
  
      if (scrollY > mainProductButtonOffset) {
        this.hide();
      } else {
        this.show();
      }
  
    }
  
    async onButtonClick() {
      this.buttonElement.classList.add('product-details__add-to-cart-button--loading');
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.dataset.variant,
          quantity: 1,
        }),
      });
      window.Shopify.getCart(function (cart) {
        var cartAmountWrap = document.querySelector('[data-header-cart-count]');
        cartAmountWrap.innerHTML = "(".concat(cart.item_count, ")");
      });
      this.buttonElement.classList.remove('product-details__add-to-cart-button--loading');
    }
  
  
    show() {
      this.classList.add('sticky-atc--visible');
    }
  
    hide() {
      this.classList.remove('sticky-atc--visible');
    }
  
    updatePrice(variant) {
      let { price, compare_at_price } = variant;
      this.priceElement.innerHTML = window.Shopify.formatMoney(price, Shopify.money_format);
    }
  }
  
  customElements.define('sticky-atc', StickyATC);


  